import React, { Component } from 'react'
import { DragSource } from 'react-dnd';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { Button, Icon, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../store/actions';
import { connect } from 'react-redux';

/* drag sources */
const itemSource = {
    beginDrag(props) {
        // console.log(props)
        return props.item;
    },
    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        let target = monitor.getDropResult()

        if (props.item.WeekNum === target.week && props.item.DayOfWeek === target.day) {
            return true
        }
        if (props.item.module_id) {
            props.toggleConfirmDragDialog(props.item, target.week, target.day)
        }
        else {
            props.onDrop(props.item, target.week, target.day)
        }
        return true
    }
}

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}

class DraggableSelectedLesson extends Component {

    state = { deleteDialog: false }

    render() {
        let { connectDragSource, isDragging, item } = this.props;

        return (
            connectDragSource(
                <div style={{ opacity: isDragging ? 0.5 : 1 }}>

                    <Dialog
                        open={this.state.deleteDialog}
                        // onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Delete entire module or single lesson?"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                You can delete this lesson individually or delete the entire module, <b>{item.ModuleName}</b>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => { this.props.onDeleteModule(item.module_id), this.setState({ deleteDialog: false }) }} color="primary">
                                Delete Module
                            </Button>
                            <Button onClick={() => { this.props.onDeleteLesson(item), this.setState({ deleteDialog: false }) }} color="primary">
                                Lesson Only
                            </Button>
                            <Button onClick={() => this.setState({ deleteDialog: false })} color="primary" autoFocus>
                                Go Back
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <SnackbarContent style={{ backgroundColor: '#DDDDDD', maxWidth: '100%', minWidth: '90%', color: 'black', fontSize: '12px' }} 
                        message={<div>{item.LessonName} <p style={{ fontSize: '10px' }}>{item.module_id ? item.ModuleName : null}</p></div>}
                        action={
                            <IconButton
                                onClick={(ev) => {
                                    if (this.props.item.module_id) {
                                        this.setState({ deleteDialog: true })
                                    }
                                    else {
                                        this.props.onDeleteLesson(this.props.item);
                                    }
                                }}
                            >
                            <Icon>delete</Icon>
                            </IconButton>}
                    />
                </div>)
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        onDeleteLesson: Actions.removeLessonFromCalendar,
        onDeleteModule: Actions.removeModuleFromCalendar
    }, dispatch);
}

function mapStateToProps({ moduleApp }) {
    return {

    }
}


export default DragSource('item', itemSource, collectSource)(withRouter(connect(mapStateToProps, mapDispatchToProps)(DraggableSelectedLesson)));


// WEBPACK FOOTER //
// src/main/content/course/scheduleComponents/DraggableSelectedLesson.js